var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-loader"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.loading)?_vm._t("default"):_c('div',[_vm._t("loader",function(){return [_c('div',{staticClass:"a-loader__spinner"},[_vm._v("\n          Loading...\n        ")])]})],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }